import { mapState } from "pinia";
import useStore from "./../store"

export default {
    computed: {
        ...mapState(useStore, ['options'])
    }
}